import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.css',
})
export class LoginPageComponent {
  private auth = inject(AuthService);
  private router = inject(Router);

  email = '';
  password = '';
  rememberMe = true;
  errorMessage = '';
  showError = false;
  isSubmitting = false;
  showPassword = false;

  onLogin(): void {
    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.auth.beginLogin(this.email, this.password).subscribe({
      next: (result) => {
        this.isSubmitting = false;
        if (!result.success) {
          this.showErrorMessage(
            result.message ?? 'Unable to sign in. Please try again.',
          );
          return;
        }

        this.router.navigate(['/otp']);
      },
      error: () => {
        this.isSubmitting = false;
        this.showErrorMessage('Unable to sign in. Please try again.');
      },
    });
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  onForgotPassword(): void {
    this.router.navigate(['/forgot-password']);
  }

  private showErrorMessage(message: string): void {
    this.showError = true;
    this.errorMessage = message;
    setTimeout(() => {
      this.showError = false;
    }, 4000);
  }
}
